module.exports = {
	"15": "UZS"
};


//////////////////
// WEBPACK FOOTER
// ./js/shared/dictionaries/accountResourcesUz.json
// module id = 1816
// module chunks = 2